import { render, staticRenderFns } from "./SoccerHowClassHeader.vue?vue&type=template&id=7b17d2af&scoped=true&"
import script from "./SoccerHowClassHeader.vue?vue&type=script&lang=js&"
export * from "./SoccerHowClassHeader.vue?vue&type=script&lang=js&"
import style0 from "./SoccerHowClassHeader.vue?vue&type=style&index=0&id=7b17d2af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b17d2af",
  null
  
)

export default component.exports